import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-edit',
  templateUrl: './reports-edit.component.html',
  styleUrls: ['./reports-edit.component.css']
})
export class ReportsEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
